export default {"src":"/_next/static/media/master.3db49eae.svg","height":167,"width":291,"blurWidth":0,"blurHeight":0};